import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Company from 'src/app/model/company/company';
import ProjectContact from 'src/app/model/company/projectContact';
import { Project } from 'src/app/model/project/project';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { AuthService } from 'src/app/services/auth.service';
import { SnackService } from 'src/app/services/snack.service';
import { ContactHelper } from '../../helpers/contact-helper';
import Contact from '../../model/Contact/contact';
import { NoEmptyProjectContactsPipe } from '../../pipes/no-empty-project-companies';
import { FormValidationService } from '../../services/form-validation.service';
import { RequestService } from '../../services/request.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { ContactPickerEvent } from './contact-picker-event';
import { CreateBaseProjectUrlParamsService } from '../../services/create-base-project-url-params.service';
import { STATUS } from '../../model/project/status';

@Component({
  selector: 'contact-picker',
  templateUrl: './contact-picker.component.html',
  styleUrls: ['./contact-picker.component.scss'],
  providers: [FormatPhoneNumber],
})
export class ContactPickerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  isMultiplePartiesDisabled: boolean;
  multipleParties: boolean;
  projectManager: ProjectContact;
  companyContacts: Contact[][];
  oldContactValue: Contact[];
  projectContactToOriginalCompany: Map<number, number>;

  @ViewChild('form', { static: true })
  public form: NgForm;

  @Input()
  public inputProject: Project;

  @Input()
  public client = false;

  @Input()
  public adminCreate = false;

  @Input()
  public invoiceSent: Subject<any>;

  @Input()
  public projectContactIdAssigned: Subject<ProjectContact[]>;

  @Input()
  public fromOldSystem: boolean = false;

  @Input()
  public ignoreIdSubmit: boolean = false;

  public projectContacts: ProjectContact[];

  @Output()
  public projectContactChange = new EventEmitter<ContactPickerEvent>();

  @Output()
  public next = new EventEmitter();

  @Output()
  public updateOtherContacts = new EventEmitter<Contact[]>();

  currentlyChosenContacts = new Set<number>();

  newClientProject: boolean = false;
  allOtherContactOptions: Contact[];
  otherContactOptions: Contact[];
  selectedOtherContacts: Contact[];

  constructor(
    private snackService: SnackService,
    private validation: FormValidationService,
    private noEmptyProjectContactsPipe: NoEmptyProjectContactsPipe,
    private requestService: RequestService,
    public formatPhoneNumber: FormatPhoneNumber,
    private authService: AuthService,
    private cd: ChangeDetectorRef,
    private createBaseProjectUrlParamsService: CreateBaseProjectUrlParamsService
  ) {
    super();
    this.isMultiplePartiesDisabled = true;
    this.multipleParties = false;
    this.companyContacts = [];
    this.projectContacts = [];
    this.oldContactValue = [];
  }

  nextPart() {
    this.next.emit();
  }

  ngOnInit() {
    if (
      this.client &&
      (this.inputProject.id == null ||
        this.inputProject.subProjects[0].status === STATUS.DRAFT)
    ) {
      this.newClientProject = true;
      this.selectedOtherContacts = [];
    }
    this.projectContacts.push(...this.inputProject.projectContacts);
    this.projectContactToOriginalCompany = new Map<number, number>();

    if (this.projectContactIdAssigned != null) {
      this.addSubscription(
        this.projectContactIdAssigned,
        (projectContacts: ProjectContact[]) => {
          let index = 0;
          this.projectContacts.forEach((pc) => {
            if (pc.id == null) {
              pc.id = projectContacts[index++].id;
              if (this.multipleParties) {
                this.addCompany();
              }
            }
          });
        }
      );
    }

    let filteredResults = this.projectContacts.filter(
      (projectContact) => projectContact.projectManager
    );
    if (filteredResults.length === 1) {
      this.projectManager = filteredResults[0];
    }
    this.projectContacts.forEach((projectContact) => {
      if (projectContact.contact != null && projectContact.contact.id != null) {
        this.currentlyChosenContacts.add(projectContact.contact.id);
      }
    });
    this.projectContacts.forEach((projectContact, index) => {
      if (projectContact.company.regularName) {
        this.addSubscription(
          this.requestService.getNormal(
            '/companies/' + projectContact.company.id
          ),
          (response) => {
            if (response) {
              let contacts = response.contacts;
              //Filter out archived contacts
              contacts = contacts.filter((c) => !c.archived);
              //If chosen contact is not in result, do include it to prevent view from breaking
              if (
                contacts.find(
                  (c) => c.id === this.projectContacts[index].contact.id
                ) == null
              ) {
                contacts.push(this.projectContacts[index].contact);
              }
              //Fill list of contact options for this company
              this.companyContacts[index] = this.filterChosenContacts(
                contacts,
                projectContact
              );
              this.oldContactValue[index] = projectContact.contact;
              //Set contact to chosen value
              this.projectContacts[index].contact = contacts.find(
                (contact) =>
                  contact.id === this.projectContacts[index].contact.id
              );
              ContactHelper.setPhoneNumberDisplays(
                this.projectContacts[index].contact,
                this.formatPhoneNumber
              );
              //enable multiple parties
              this.isMultiplePartiesDisabled = false;
            }
          }
        );
      }
    });
    if (this.projectContacts.length > 1) {
      this.multipleParties = true;
      this.multipleCompaniesChecked(true, true); //call 1 van extra lijn
    }

    if (
      this.inputProject.id != null &&
      this.inputProject.subProjects[0].status === STATUS.DRAFT
    ) {
      this.selectCompany(this.inputProject.projectContacts[0].company, 0);
    }
  }

  companyAlreadySelected(company): boolean {
    for (let projectContact of this.projectContacts) {
      if (projectContact.company.id === company.id) {
        return true;
      }
    }
    return false;
  }

  selectCompany(company, index) {
    const projectContact = this.projectContacts[index];
    if (projectContact.id != null && projectContact.company != null) {
      if (
        projectContact.company.id != company.id &&
        !this.projectContactToOriginalCompany.has(projectContact.id)
      ) {
        this.projectContactToOriginalCompany.set(
          projectContact.id,
          projectContact.company.id
        );
      } else if (
        this.projectContactToOriginalCompany.get(projectContact.id) ===
        company.id
      ) {
        this.projectContactToOriginalCompany.delete(projectContact.id);
      }
    }
    projectContact.company = company;
    const nonArchivedContacts = company.contacts.filter((c) => !c.archived);
    this.companyContacts[index] = this.filterChosenContacts(
      nonArchivedContacts,
      projectContact
    );
    this.oldContactValue[index] = null;
    if (this.newClientProject) {
      // for now there is only one 'real' projectContact row for the client form, so this is the moment to initialize the other options
      this.prepareOtherContactOptions(nonArchivedContacts);
      this.tryFillUserContact(company);
      this.cd.detectChanges();
    }
  }

  filterChosenContacts(
    contacts: Contact[],
    currentProjectContact: ProjectContact
  ) {
    if (contacts == null) {
      return contacts;
    }
    return contacts.filter(
      (c) =>
        !this.currentlyChosenContacts.has(c.id) ||
        (currentProjectContact.contact != null &&
          currentProjectContact.contact.id === c.id)
    );
  }

  contactChange(contact, index) {
    ContactHelper.setPhoneNumberDisplays(contact, this.formatPhoneNumber);
    this.isMultiplePartiesDisabled = false;
    if (contact != null && contact.id != null) {
      this.currentlyChosenContacts.add(contact.id);
      this.companyContacts.forEach((contacts, j) => {
        if (index !== j) {
          const contactIndex = contacts.findIndex((c) => c.id === contact.id);
          if (contactIndex >= 0) {
            contacts.splice(contactIndex, 1);
          }
        }
      });
    }
    if (this.oldContactValue[index] != null) {
      this.contactUnassigned(
        this.oldContactValue[index],
        this.projectContacts[index],
        index
      );
    }
    this.oldContactValue[index] = contact;
    if (this.inputProject.id || this.ignoreIdSubmit) {
      this.onSubmit(this.form);
    }
    if (this.newClientProject) {
      this.recalculateOtherContactOptions(contact);
    }
    if (this.multipleParties) {
      this.addCompany();
    }
  }

  contactUnassigned(contact, projectContact, i) {
    if (contact == null || projectContact.company == null) {
      return;
    }
    if (contact.id != null) {
      this.currentlyChosenContacts.delete(contact.id);
    }
    this.companyContacts.forEach((contacts, j) => {
      const companyId =
        this.projectContacts[j].company != null
          ? this.projectContacts[j].company.id
          : null;
      if (
        companyId != null &&
        i !== j &&
        projectContact.company.id === companyId
      ) {
        contacts.push(contact);
      }
    });
  }

  addCompany() {
    const emptyContact = this.projectContacts.find(
      (pc) => !pc.hasOwnProperty('id') || pc.id == null
    );
    if (emptyContact == null) {
      this.projectContacts.push(new ProjectContact());
    }
  }

  selectProjectManager($event) {
    let chosenProjectManager: ProjectContact = $event.value;
    this.setProjectManager(chosenProjectManager);
  }

  setProjectManager(pm) {
    this.projectManager = pm;
    this.projectContacts.forEach(
      (projectContact) => (projectContact.projectManager = false)
    );
    this.projectContacts[this.projectContacts.indexOf(pm)].projectManager =
      true;
    if (this.inputProject.id || this.ignoreIdSubmit) {
      this.onSubmit(this.form);
    }
  }

  onSubmit(contactForm: NgForm) {
    if (
      !this.client ||
      this.inputProject.id == null ||
      this.inputProject.subProjects[0].status === STATUS.DRAFT.valueOf()
    ) {
      this.addSubscription(
        this.validation.validateForm(contactForm),
        (valid) => {
          if (
            this.multipleParties &&
            !this.projectContacts.find(
              (projectContact) => projectContact.projectManager
            )
          ) {
            valid = false;
          }
          if (
            this.inputProject.collaborative &&
            this.client &&
            (!CollectionHelper.isPopulated(
              this.inputProject.projectExtraCompanyContacts
            ) ||
              this.inputProject.projectExtraCompanyContacts.some(
                (ec) =>
                  StringHelper.isEmpty(ec.company) ||
                  StringHelper.isEmpty(ec.contact)
              ))
          ) {
            valid = false;
          }
          if (valid) {
            if (
              this.projectContacts.length > 0 &&
              this.projectContacts[0].contact.firstName != null
            ) {
              this.projectContacts = this.noEmptyProjectContactsPipe.transform(
                this.projectContacts
              );
              if (this.projectContacts.length === 1) {
                this.projectContacts[0].projectManager = true;
              }
              if (
                this.inputProject.id == null ||
                this.inputProject.subProjects[0].status ===
                  STATUS.DRAFT.valueOf()
              ) {
                this.projectContactChange.emit({
                  projectContacts: [...this.projectContacts],
                  replacedCompanies: null,
                });
              } else {
                const replacedCompanies =
                  this.projectContactToOriginalCompany.size > 0
                    ? this.processOriginalCompanies()
                    : null;
                this.projectContactToOriginalCompany.clear();
                this.projectContactChange.emit({
                  projectContacts: [...this.projectContacts],
                  replacedCompanies: replacedCompanies,
                });
              }
              if (this.multipleParties) {
                this.addCompany();
              }
            } else {
              this.snackService.showWarning(
                'Gelieve minstens 1 contact toe te voegen'
              );
            }
          } else {
            this.snackService.showWarning(
              'Gelieve alle verplichte velden in te vullen'
            );
          }
        }
      );
    } else {
      const replacedCompanies =
        this.projectContactToOriginalCompany.size > 0
          ? this.processOriginalCompanies()
          : null;
      this.projectContactToOriginalCompany.clear();
      this.projectContactChange.emit({
        projectContacts: [...this.projectContacts],
        replacedCompanies: replacedCompanies,
      });
    }
  }

  private processOriginalCompanies(): Map<number, Company> {
    const toReturn = new Map<number, Company>();
    this.projectContacts.forEach((pc) => {
      if (this.projectContactToOriginalCompany.has(pc.id)) {
        toReturn.set(
          this.projectContactToOriginalCompany.get(pc.id),
          pc.company
        );
      }
    });
    return toReturn;
  }

  multipleCompaniesChecked(event, addCompany: boolean) {
    this.multipleParties = event;
    if (event) {
      if (this.projectManager == null) {
        this.setProjectManager(this.projectContacts[0]);
      }
      if (addCompany) {
        this.addCompany();
      }
    } else {
      this.removeAllContactsButOne();
    }
  }

  removeAllContactsButOne() {
    let size = this.projectContacts.length - 1;
    for (let i = 0; i < size; i++) {
      this.removeCompany();
    }
    this.projectContacts[0].projectManager = true;
  }

  removeCompany() {
    if (this.projectContacts.length > 1) {
      this.projectContacts.pop();
    }
  }

  deleteProjectContact(projectContactToDelete: ProjectContact) {
    this.projectContacts = this.projectContacts.filter(
      (projectContact) => projectContact != projectContactToDelete
    );
    if (this.projectContacts.length < 2) {
      this.multipleCompaniesChecked(false, true);
    }
    if (this.inputProject.id || this.ignoreIdSubmit) {
      this.onSubmit(this.form);
    }
  }

  otherCompaniesChange(event) {
    this.inputProject.otherCompanies = event;
  }

  showCloseButton(projectContact: ProjectContact) {
    return (
      !projectContact.contact.id ||
      this.projectContacts.length <= 2 ||
      (projectContact.contact.id && this.projectContacts.length > 2)
    );
  }

  contactAlreadySelected(contact: Contact): boolean {
    return this.currentlyChosenContacts.has(contact.id);
  }

  filterContact(value: string, c: Contact) {
    if (value == null) {
      value = '';
    }
    if (c.firstName != null && c.lastName != null) {
      return (
        c.firstName.toLowerCase().trim().includes(value.toLowerCase()) ||
        c.lastName.toLowerCase().trim().includes(value.toLowerCase()) ||
        (c.firstName.trim() + ' ' + c.lastName.trim())
          .toLowerCase()
          .includes(value.toLowerCase()) ||
        (c.lastName.trim() + ' ' + c.firstName.trim())
          .toLowerCase()
          .includes(value.toLowerCase())
      );
    }
    if (c.firstName != null) {
      return c.firstName.toLowerCase().trim().includes(value.toLowerCase());
    }
    if (c.lastName != null) {
      return c.lastName.toLowerCase().trim().includes(value.toLowerCase());
    }
    return false;
  }

  displayContact(c: Contact) {
    return c.firstName + ' ' + c.lastName;
  }

  private prepareOtherContactOptions(nonArchivedContacts: Contact[]): void {
    this.selectedOtherContacts.length = 0;
    this.allOtherContactOptions = [...nonArchivedContacts];
    this.allOtherContactOptions.forEach((oc) =>
      ContactHelper.setPhoneNumberDisplays(oc, this.formatPhoneNumber)
    );
    this.otherContactOptions = [...this.allOtherContactOptions];
  }

  private recalculateOtherContactOptions(selectedContact: Contact): void {
    this.otherContactOptions = this.allOtherContactOptions.filter(
      (c) => c.id !== selectedContact.id
    );
    if (CollectionHelper.isPopulated(this.selectedOtherContacts)) {
      CollectionHelper.filterInPlace(
        this.selectedOtherContacts,
        (c) => c.id !== selectedContact.id
      );
      this.updateOtherContacts.emit(this.selectedOtherContacts);
    }
  }

  private tryFillUserContact(company: Company): void {
    const matchingContact = ContactHelper.getMatchingContact(
      company.contacts,
      this.authService.getAuthenticatedUser()
    );
    if (matchingContact != null) {
      this.projectContacts[0].contact = matchingContact;
      this.recalculateOtherContactOptions(matchingContact);
    }

    this.selectContactFromParams(company);
  }

  private selectContactFromParams(company: Company) {
    if (!CollectionHelper.isPopulated(company.contacts)) return;

    const params =
      this.createBaseProjectUrlParamsService.getCreateBaseProjectUrlParams();
    if (!params.company_contact) return;

    const contact = company.contacts.find((contact) =>
      contact.emails
        .map((email) => email.email)
        .includes(params.company_contact)
    );

    if (!contact) return;

    this.projectContacts[0].contact = contact;

    this.recalculateOtherContactOptions(contact);
  }

  collaborativeChange(value: boolean): void {
    this.inputProject.collaborative = value;
  }

  otherContactsChange(): void {
    this.updateOtherContacts.emit(this.selectedOtherContacts);
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  trackById(index: number, obj: any) {
    return GeneralHelper.trackById(index, obj);
  }

  protected readonly STATUS = STATUS;
}
